<template>
    <div class="Footer">
		<div class="Footer__networks">
			<span @click="goToSocialNetworkPage('https://www.facebook.com/rocketprintdoo/')">
				<Facebook class="icon" />
			</span>
			<span @click="goToSocialNetworkPage('https://www.instagram.com/rocketprint.ba/')">
				<Instagram class="icon" />
			</span>
		</div>
        <div class="Footer__copyright">
            <p>©2019 RocketPrint d.o.o. All rights reserved</p>
        </div>
    </div>
</template>

<script>
import Facebook from 'vue-material-design-icons/Facebook.vue'
import Instagram from 'vue-material-design-icons/Instagram.vue'

export default {
	name: 'Footer',
	components: {
		Facebook,
		Instagram
	},
	methods: {
		goToSocialNetworkPage(url) {
			window.open(url, '_blank');
		}
	}
}
</script>

<style lang="scss" scoped>

.Footer {
    background: darken($grey, 5);
    min-height: 15vh;
	display: flex;
	flex-wrap: wrap;
    justify-content: center;
    align-items: center;
	padding: 10px;
	
	&__networks {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-bottom: 10px;

		& > span {
			margin: 0 5px;
		}

		span {
			cursor: pointer;
			@include transition(0.2);

			.icon {
				font-size: 2em;
				color: white;
			}

			&:hover {
				.icon {
					color: lighten($blue, 10);
				}
			}
		}
	}

	&__copyright {
		// width: 50%;
	}

    p {
        margin: 0;
        @include paragraphStyle(0.7, white, 0)
    }
}

</style>
